import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext.js';
import { updateUserTier } from '../utils/userUtils.js';
import { TIER_LEVELS } from '../utils/tierSystem.js';

const TierUpgrade = () => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleTierUpgrade = async (newTier) => {
    try {
      setLoading(true);
      setError(null);
      
      await updateUserTier(currentUser.uid, newTier);
      
      // Refresh the page to show updated tier
      window.location.reload();
    } catch (err) {
      setError('Failed to upgrade tier. Please try again.');
      console.error('Error upgrading tier:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-harmony-blue-dark rounded-lg p-6">
      <h2 className="text-2xl font-bold text-harmony-white mb-6">Upgrade Your Tier</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Object.entries(TIER_LEVELS).map(([tierKey, tierData]) => (
          <div 
            key={tierKey}
            className="bg-harmony-blue/20 rounded-lg p-6 border border-harmony-white/10"
          >
            <h3 className="text-xl font-semibold text-harmony-white mb-4">{tierData.name}</h3>
            <div className="space-y-4">
              <div>
                <p className="text-harmony-white/60 mb-2">Requirements:</p>
                <ul className="list-disc list-inside text-harmony-white">
                  <li>Spend: ${tierData.requirements.spend}</li>
                  <li>Referrals: {tierData.requirements.referrals}</li>
                </ul>
              </div>
              <div>
                <p className="text-harmony-white/60 mb-2">Benefits:</p>
                <ul className="list-disc list-inside text-harmony-white">
                  <li>Stream Quality: {tierData.benefits.streamQuality}</li>
                  <li>Custom Emotes: {tierData.benefits.customEmotes}</li>
                  <li>Sub Revenue: {tierData.benefits.subRevenue * 100}%</li>
                  <li>Ad Revenue: {tierData.benefits.adRevenue * 100}%</li>
                </ul>
              </div>
              <button
                onClick={() => handleTierUpgrade(tierKey)}
                disabled={loading || currentUser?.tier === tierKey}
                className={`w-full py-2 px-4 rounded-lg font-semibold transition-colors ${
                  currentUser?.tier === tierKey
                    ? 'bg-harmony-orange/50 text-harmony-white/50 cursor-not-allowed'
                    : 'bg-harmony-orange text-harmony-white hover:bg-harmony-orange/90'
                }`}
              >
                {currentUser?.tier === tierKey ? 'Current Tier' : 'Upgrade to ' + tierData.name}
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {error && (
        <div className="mt-4 p-4 bg-red-500/20 text-red-500 rounded-lg">
          {error}
        </div>
      )}
    </div>
  );
};

export default TierUpgrade; 